<script setup>

import {computed} from "vue";
import {checkDataElement} from "../../apps/base";

const model = defineModel({default: ''});
const props = defineProps({
    dataElement: String,
    dataElementPrefix: String,
    checked: Boolean,
    disabled: Boolean,
    label: String,
    error: Boolean,
    name: String,
    id: String,
});
const inputId = props.id ? props.id : 'checkbox_' + Math.round(Math.random() * 1e6);


const wrapClasses = computed(() => {
    let classes = [];

    if (props.error && !props.disabled) {
        classes.push('has-error');
    }

    if (model.value) {
        classes.push('has-value');
    }

    return classes
});

const onChange = () => {
    model.value = !!model.value ? '' : 'Y';
}

</script>

<template>
    <div class="form-group" :class="wrapClasses">
        <input
            :data-element="checkDataElement(dataElement ? dataElement : dataElementPrefix + 'checkbox-' + name)"
            type="checkbox"
            :id="inputId"
            :checked="!!model"
            @change="onChange"
            :disabled="disabled"
        />
        <label :data-element="checkDataElement(dataElementPrefix + 'label-'+name)" :for="inputId" v-html="label"></label>
    </div>
</template>

<script>
/* global Mango */
export default {
    name: "FieldCheckbox",
}
</script>